!(function (t, e) {
    "object" == typeof exports && "undefined" != typeof module
        ? (module.exports = e())
        : "function" == typeof define && define.amd
          ? define(e)
          : ((t = "undefined" != typeof globalThis ? globalThis : t || self).EmblaCarousel = e());
})(this, function () {
    "use strict";
    function t(t) {
        return "number" == typeof t;
    }
    function e(t) {
        return "string" == typeof t;
    }
    function n(t) {
        return "boolean" == typeof t;
    }
    function o(t) {
        return "[object Object]" === Object.prototype.toString.call(t);
    }
    function i(t) {
        return Math.abs(t);
    }
    function r(t) {
        return Math.sign(t);
    }
    function s(t, e) {
        return i(t - e);
    }
    function a(t) {
        return f(t).map(Number);
    }
    function c(t) {
        return t[l(t)];
    }
    function l(t) {
        return Math.max(0, t.length - 1);
    }
    function u(t, e) {
        return e === l(t);
    }
    function d(t, e = 0) {
        return Array.from(Array(t), (t, n) => e + n);
    }
    function f(t) {
        return Object.keys(t);
    }
    function p(t, e) {
        return [t, e].reduce(
            (t, e) => (
                f(e).forEach((n) => {
                    const i = t[n],
                        r = e[n],
                        s = o(i) && o(r);
                    t[n] = s ? p(i, r) : r;
                }),
                t
            ),
            {}
        );
    }
    function m(t, e) {
        return void 0 !== e.MouseEvent && t instanceof e.MouseEvent;
    }
    function h() {
        let t = [];
        const e = {
            add: function (n, o, i, r = { passive: !0 }) {
                let s;
                if ("addEventListener" in n) n.addEventListener(o, i, r), (s = () => n.removeEventListener(o, i, r));
                else {
                    const t = n;
                    t.addListener(i), (s = () => t.removeListener(i));
                }
                return t.push(s), e;
            },
            clear: function () {
                t = t.filter((t) => t());
            },
        };
        return e;
    }
    function g(t = 0, e = 0) {
        const n = i(t - e);
        function o(e) {
            return e < t;
        }
        function r(t) {
            return t > e;
        }
        function s(t) {
            return o(t) || r(t);
        }
        return {
            length: n,
            max: e,
            min: t,
            constrain: function (n) {
                return s(n) ? (o(n) ? t : e) : n;
            },
            reachedAny: s,
            reachedMax: r,
            reachedMin: o,
            removeOffset: function (t) {
                return n ? t - n * Math.ceil((t - e) / n) : t;
            },
        };
    }
    function v(t, e, n) {
        const { constrain: o } = g(0, t),
            r = t + 1;
        let s = a(e);
        function a(t) {
            return n ? i((r + t) % r) : o(t);
        }
        function c() {
            return s;
        }
        function l() {
            return v(t, c(), n);
        }
        const u = {
            get: c,
            set: function (t) {
                return (s = a(t)), u;
            },
            add: function (t) {
                return l().set(c() + t);
            },
            clone: l,
        };
        return u;
    }
    function y(t, e, o, a, c, l, u, d, f, p, v, y, S, b, E, w, x, M, T) {
        const { cross: L, direction: A } = t,
            O = ["INPUT", "SELECT", "TEXTAREA"],
            D = { passive: !1 },
            F = h(),
            I = h(),
            N = g(50, 225).constrain(b.measure(20)),
            P = { mouse: 300, touch: 400 },
            k = { mouse: 500, touch: 600 },
            C = E ? 43 : 25;
        let V = !1,
            _ = 0,
            z = 0,
            H = !1,
            B = !1,
            R = !1,
            q = !1;
        function j(t) {
            if (!m(t, a) && t.touches.length >= 2) return W(t);
            const e = l.readPoint(t),
                n = l.readPoint(t, L),
                o = s(e, _),
                i = s(n, z);
            if (!B && !q) {
                if (!t.cancelable) return W(t);
                if (((B = o > i), !B)) return W(t);
            }
            const r = l.pointerMove(t);
            o > w && (R = !0), p.useFriction(0.3).useDuration(0.75), d.start(), c.add(A(r)), t.preventDefault();
        }
        function W(t) {
            const e = v.byDistance(0, !1).index !== y.get(),
                n = l.pointerUp(t) * (E ? k : P)[q ? "mouse" : "touch"],
                o = (function (t, e) {
                    const n = y.add(-1 * r(t)),
                        o = v.byDistance(t, !E).distance;
                    return E || i(t) < N ? o : x && e ? 0.5 * o : v.byIndex(n.get(), 0).distance;
                })(A(n), e),
                a = (function (t, e) {
                    if (0 === t || 0 === e) return 0;
                    if (i(t) <= i(e)) return 0;
                    const n = s(i(t), i(e));
                    return i(n / t);
                })(n, o),
                c = C - 10 * a,
                u = M + a / 50;
            (B = !1),
                (H = !1),
                I.clear(),
                p.useDuration(c).useFriction(u),
                f.distance(o, !E),
                (q = !1),
                S.emit("pointerUp");
        }
        function X(t) {
            R && (t.stopPropagation(), t.preventDefault(), (R = !1));
        }
        return {
            init: function (t) {
                if (!T) return;
                function i(i) {
                    (n(T) || T(t, i)) &&
                        (function (t) {
                            const n = m(t, a);
                            (q = n),
                                (R = E && n && !t.buttons && V),
                                (V = s(c.get(), u.get()) >= 2),
                                (n && 0 !== t.button) ||
                                    (function (t) {
                                        const e = t.nodeName || "";
                                        return O.includes(e);
                                    })(t.target) ||
                                    ((H = !0),
                                    l.pointerDown(t),
                                    p.useFriction(0).useDuration(0),
                                    c.set(u),
                                    (function () {
                                        const t = q ? o : e;
                                        I.add(t, "touchmove", j, D)
                                            .add(t, "touchend", W)
                                            .add(t, "mousemove", j, D)
                                            .add(t, "mouseup", W);
                                    })(),
                                    (_ = l.readPoint(t)),
                                    (z = l.readPoint(t, L)),
                                    S.emit("pointerDown"));
                        })(i);
                }
                const r = e;
                F.add(r, "dragstart", (t) => t.preventDefault(), D)
                    .add(r, "touchmove", () => {}, D)
                    .add(r, "touchend", () => {})
                    .add(r, "touchstart", i)
                    .add(r, "mousedown", i)
                    .add(r, "touchcancel", W)
                    .add(r, "contextmenu", W)
                    .add(r, "click", X, !0);
            },
            destroy: function () {
                F.clear(), I.clear();
            },
            pointerDown: function () {
                return H;
            },
        };
    }
    function S(t, e) {
        let n, o;
        function r(t) {
            return t.timeStamp;
        }
        function s(n, o) {
            const i = "client" + ("x" === (o || t.scroll) ? "X" : "Y");
            return (m(n, e) ? n : n.touches[0])[i];
        }
        return {
            pointerDown: function (t) {
                return (n = t), (o = t), s(t);
            },
            pointerMove: function (t) {
                const e = s(t) - s(o),
                    i = r(t) - r(n) > 170;
                return (o = t), i && (n = t), e;
            },
            pointerUp: function (t) {
                if (!n || !o) return 0;
                const e = s(o) - s(n),
                    a = r(t) - r(n),
                    c = r(t) - r(o) > 170,
                    l = e / a;
                return a && !c && i(l) > 0.1 ? l : 0;
            },
            readPoint: s,
        };
    }
    function b(t, e, o, r, s, a, c) {
        const l = [t].concat(r);
        let u,
            d,
            f = [],
            p = !1;
        function m(t) {
            return s.measureSize(c.measure(t));
        }
        return {
            init: function (s) {
                a &&
                    ((d = m(t)),
                    (f = r.map(m)),
                    (u = new ResizeObserver((o) => {
                        (n(a) || a(s, o)) &&
                            (function (n) {
                                for (const o of n) {
                                    if (p) return;
                                    const n = o.target === t,
                                        a = r.indexOf(o.target),
                                        c = n ? d : f[a];
                                    if (i(m(n ? t : r[a]) - c) >= 0.5) {
                                        s.reInit(), e.emit("resize");
                                        break;
                                    }
                                }
                            })(o);
                    })),
                    o.requestAnimationFrame(() => {
                        l.forEach((t) => u.observe(t));
                    }));
            },
            destroy: function () {
                (p = !0), u && u.disconnect();
            },
        };
    }
    function E(t, e, n, o, r) {
        const s = r.measure(10),
            a = r.measure(50),
            c = g(0.1, 0.99);
        let l = !1;
        function u() {
            return !l && !!t.reachedAny(n.get()) && !!t.reachedAny(e.get());
        }
        return {
            shouldConstrain: u,
            constrain: function (r) {
                if (!u()) return;
                const l = t.reachedMin(e.get()) ? "min" : "max",
                    d = i(t[l] - e.get()),
                    f = n.get() - e.get(),
                    p = c.constrain(d / a);
                n.subtract(f * p), !r && i(f) < s && (n.set(t.constrain(n.get())), o.useDuration(25).useBaseFriction());
            },
            toggleActive: function (t) {
                l = !t;
            },
        };
    }
    function w(t, e, n, o) {
        const i = e.min + 0.1,
            r = e.max + 0.1,
            { reachedMin: s, reachedMax: a } = g(i, r);
        return {
            loop: function (e) {
                if (
                    !(function (t) {
                        return 1 === t ? a(n.get()) : -1 === t && s(n.get());
                    })(e)
                )
                    return;
                const i = t * (-1 * e);
                o.forEach((t) => t.add(i));
            },
        };
    }
    function x(e, o, i, r, s, a, c, l) {
        const u = { passive: !0, capture: !0 };
        let d = 0;
        function f(t) {
            "Tab" === t.code && (d = new Date().getTime());
        }
        return {
            init: function (p) {
                l &&
                    (a.add(document, "keydown", f, !1),
                    o.forEach((o, f) => {
                        a.add(
                            o,
                            "focus",
                            (o) => {
                                (n(l) || l(p, o)) &&
                                    (function (n) {
                                        if (new Date().getTime() - d > 10) return;
                                        c.emit("slideFocusStart"), (e.scrollLeft = 0);
                                        const o = i.findIndex((t) => t.includes(n));
                                        t(o) && (s.useDuration(0), r.index(o, 0), c.emit("slideFocus"));
                                    })(f);
                            },
                            u
                        );
                    }));
            },
        };
    }
    function M(e) {
        let n = e;
        function o(e) {
            return t(e) ? e : e.get();
        }
        return {
            get: function () {
                return n;
            },
            set: function (t) {
                n = o(t);
            },
            add: function (t) {
                n += o(t);
            },
            subtract: function (t) {
                n -= o(t);
            },
        };
    }
    function T(t, e) {
        const n =
                "x" === t.scroll
                    ? function (t) {
                          return `translate3d(${t}px,0px,0px)`;
                      }
                    : function (t) {
                          return `translate3d(0px,${t}px,0px)`;
                      },
            o = e.style;
        let i = null,
            r = !1;
        return {
            clear: function () {
                r || ((o.transform = ""), e.getAttribute("style") || e.removeAttribute("style"));
            },
            to: function (e) {
                if (r) return;
                const s = ((a = t.direction(e)), Math.round(100 * a) / 100);
                var a;
                s !== i && ((o.transform = n(s)), (i = s));
            },
            toggleActive: function (t) {
                r = !t;
            },
        };
    }
    function L(t, e, n, o, i, r, s, c, l) {
        const u = a(i),
            d = a(i).reverse(),
            f = (function () {
                const t = s[0];
                return h(m(d, t), n, !1);
            })().concat(
                (function () {
                    const t = e - s[0] - 1;
                    return h(m(u, t), -n, !0);
                })()
            );
        function p(t, e) {
            return t.reduce((t, e) => t - i[e], e);
        }
        function m(t, e) {
            return t.reduce((t, n) => (p(t, e) > 0 ? t.concat([n]) : t), []);
        }
        function h(i, s, a) {
            const u = (function (t) {
                return r.map((n, i) => ({ start: n - o[i] + 0.5 + t, end: n + e - 0.5 + t }));
            })(s);
            return i.map((e) => {
                const o = a ? 0 : -n,
                    i = a ? n : 0,
                    r = a ? "end" : "start",
                    s = u[e][r];
                return {
                    index: e,
                    loopPoint: s,
                    slideLocation: M(-1),
                    translate: T(t, l[e]),
                    target: () => (c.get() > s ? o : i),
                };
            });
        }
        return {
            canLoop: function () {
                return f.every(
                    ({ index: t }) =>
                        p(
                            u.filter((e) => e !== t),
                            e
                        ) <= 0.1
                );
            },
            clear: function () {
                f.forEach((t) => t.translate.clear());
            },
            loop: function () {
                f.forEach((t) => {
                    const { target: e, translate: n, slideLocation: o } = t,
                        i = e();
                    i !== o.get() && (n.to(i), o.set(i));
                });
            },
            loopPoints: f,
        };
    }
    function A(t, e, o) {
        let i,
            r = !1;
        return {
            init: function (s) {
                o &&
                    ((i = new MutationObserver((t) => {
                        r ||
                            ((n(o) || o(s, t)) &&
                                (function (t) {
                                    for (const n of t)
                                        if ("childList" === n.type) {
                                            s.reInit(), e.emit("slidesChanged");
                                            break;
                                        }
                                })(t));
                    })),
                    i.observe(t, { childList: !0 }));
            },
            destroy: function () {
                i && i.disconnect(), (r = !0);
            },
        };
    }
    function O(t, e, n, o) {
        const i = {};
        let r,
            s = null,
            a = null,
            c = !1;
        return {
            init: function () {
                (r = new IntersectionObserver(
                    (t) => {
                        c ||
                            (t.forEach((t) => {
                                const n = e.indexOf(t.target);
                                i[n] = t;
                            }),
                            (s = null),
                            (a = null),
                            n.emit("slidesInView"));
                    },
                    { root: t.parentElement, threshold: o }
                )),
                    e.forEach((t) => r.observe(t));
            },
            destroy: function () {
                r && r.disconnect(), (c = !0);
            },
            get: function (t = !0) {
                if (t && s) return s;
                if (!t && a) return a;
                const e = (function (t) {
                    return f(i).reduce((e, n) => {
                        const o = parseInt(n),
                            { isIntersecting: r } = i[o];
                        return ((t && r) || (!t && !r)) && e.push(o), e;
                    }, []);
                })(t);
                return t && (s = e), t || (a = e), e;
            },
        };
    }
    function D(e, n, o, r, s, u, d, f, p) {
        const { startEdge: m, endEdge: h, direction: g } = e,
            v = t(o);
        return {
            groupSlides: function (t) {
                return v
                    ? (function (t, e) {
                          return a(t)
                              .filter((t) => t % e == 0)
                              .map((n) => t.slice(n, n + e));
                      })(t, o)
                    : (function (t) {
                          return t.length
                              ? a(t)
                                    .reduce((e, o, a) => {
                                        const v = c(e) || 0,
                                            y = 0 === v,
                                            S = o === l(t),
                                            b = s[m] - u[v][m],
                                            E = s[m] - u[o][h],
                                            w = !r && y ? g(d) : 0,
                                            x = i(E - (!r && S ? g(f) : 0) - (b + w));
                                        return a && x > n + p && e.push(o), S && e.push(t.length), e;
                                    }, [])
                                    .map((e, n, o) => {
                                        const i = Math.max(o[n - 1] || 0);
                                        return t.slice(i, e);
                                    })
                              : [];
                      })(t);
            },
        };
    }
    function F(t, n, o, f, p, m, F) {
        const {
                align: I,
                axis: N,
                direction: P,
                startIndex: k,
                loop: C,
                duration: V,
                dragFree: _,
                dragThreshold: z,
                inViewThreshold: H,
                slidesToScroll: B,
                skipSnaps: R,
                containScroll: q,
                watchResize: j,
                watchSlides: W,
                watchDrag: X,
                watchFocus: U,
            } = m,
            $ = {
                measure: function (t) {
                    const { offsetTop: e, offsetLeft: n, offsetWidth: o, offsetHeight: i } = t;
                    return { top: e, right: n + o, bottom: e + i, left: n, width: o, height: i };
                },
            },
            K = $.measure(n),
            G = o.map($.measure),
            Y = (function (t, e) {
                const n = "rtl" === e,
                    o = "y" === t,
                    i = !o && n ? -1 : 1;
                return {
                    scroll: o ? "y" : "x",
                    cross: o ? "x" : "y",
                    startEdge: o ? "top" : n ? "right" : "left",
                    endEdge: o ? "bottom" : n ? "left" : "right",
                    measureSize: function (t) {
                        const { height: e, width: n } = t;
                        return o ? e : n;
                    },
                    direction: function (t) {
                        return t * i;
                    },
                };
            })(N, P),
            J = Y.measureSize(K),
            Q = (function (t) {
                return {
                    measure: function (e) {
                        return t * (e / 100);
                    },
                };
            })(J),
            Z = (function (t, n) {
                const o = {
                    start: function () {
                        return 0;
                    },
                    center: function (t) {
                        return i(t) / 2;
                    },
                    end: i,
                };
                function i(t) {
                    return n - t;
                }
                return {
                    measure: function (i, r) {
                        return e(t) ? o[t](i) : t(n, i, r);
                    },
                };
            })(I, J),
            tt = !C && !!q,
            et = C || !!q,
            {
                slideSizes: nt,
                slideSizesWithGaps: ot,
                startGap: it,
                endGap: rt,
            } = (function (t, e, n, o, r, s) {
                const { measureSize: a, startEdge: l, endEdge: d } = t,
                    f = n[0] && r,
                    p = (function () {
                        if (!f) return 0;
                        const t = n[0];
                        return i(e[l] - t[l]);
                    })(),
                    m = (function () {
                        if (!f) return 0;
                        const t = s.getComputedStyle(c(o));
                        return parseFloat(t.getPropertyValue(`margin-${d}`));
                    })(),
                    h = n.map(a),
                    g = n
                        .map((t, e, n) => {
                            const o = !e,
                                i = u(n, e);
                            return o ? h[e] + p : i ? h[e] + m : n[e + 1][l] - t[l];
                        })
                        .map(i);
                return { slideSizes: h, slideSizesWithGaps: g, startGap: p, endGap: m };
            })(Y, K, G, o, et, p),
            st = D(Y, J, B, C, K, G, it, rt, 2),
            { snaps: at, snapsAligned: ct } = (function (t, e, n, o, r) {
                const { startEdge: s, endEdge: a } = t,
                    { groupSlides: l } = r,
                    u = l(o)
                        .map((t) => c(t)[a] - t[0][s])
                        .map(i)
                        .map(e.measure),
                    d = o.map((t) => n[s] - t[s]).map((t) => -i(t)),
                    f = l(d)
                        .map((t) => t[0])
                        .map((t, e) => t + u[e]);
                return { snaps: d, snapsAligned: f };
            })(Y, Z, K, G, st),
            lt = -c(at) + c(ot),
            { snapsContained: ut, scrollContainLimit: dt } = (function (t, e, n, o) {
                const i = g(-e + t, 0),
                    r = n
                        .map((t, e) => {
                            const { min: o, max: r } = i,
                                s = i.constrain(t),
                                a = !e,
                                c = u(n, e);
                            return a ? r : c || l(o, s) ? o : l(r, s) ? r : s;
                        })
                        .map((t) => parseFloat(t.toFixed(3))),
                    a = (function () {
                        const t = r[0],
                            e = c(r);
                        return g(r.lastIndexOf(t), r.indexOf(e) + 1);
                    })();
                function l(t, e) {
                    return s(t, e) <= 1;
                }
                return {
                    snapsContained: (function () {
                        if (e <= t + 2) return [i.max];
                        if ("keepSnaps" === o) return r;
                        const { min: n, max: s } = a;
                        return r.slice(n, s);
                    })(),
                    scrollContainLimit: a,
                };
            })(J, lt, ct, q),
            ft = tt ? ut : ct,
            { limit: pt } = (function (t, e, n) {
                const o = e[0];
                return { limit: g(n ? o - t : c(e), o) };
            })(lt, ft, C),
            mt = v(l(ft), k, C),
            ht = mt.clone(),
            gt = a(o),
            vt = (function (t, e, n, o) {
                const i = h(),
                    r = 1e3 / 60;
                let s = null,
                    a = 0,
                    c = 0;
                function l(t) {
                    if (!c) return;
                    s || ((s = t), n(), n());
                    const i = t - s;
                    for (s = t, a += i; a >= r; ) n(), (a -= r);
                    o(a / r), c && (c = e.requestAnimationFrame(l));
                }
                function u() {
                    e.cancelAnimationFrame(c), (s = null), (a = 0), (c = 0);
                }
                return {
                    init: function () {
                        i.add(t, "visibilitychange", () => {
                            t.hidden && ((s = null), (a = 0));
                        });
                    },
                    destroy: function () {
                        u(), i.clear();
                    },
                    start: function () {
                        c || (c = e.requestAnimationFrame(l));
                    },
                    stop: u,
                    update: n,
                    render: o,
                };
            })(
                f,
                p,
                () =>
                    (({ dragHandler: t, scrollBody: e, scrollBounds: n, options: { loop: o } }) => {
                        o || n.constrain(t.pointerDown()), e.seek();
                    })(It),
                (t) =>
                    ((
                        {
                            scrollBody: t,
                            translate: e,
                            location: n,
                            offsetLocation: o,
                            previousLocation: i,
                            scrollLooper: r,
                            slideLooper: s,
                            dragHandler: a,
                            animation: c,
                            eventHandler: l,
                            scrollBounds: u,
                            options: { loop: d },
                        },
                        f
                    ) => {
                        const p = t.settled(),
                            m = !u.shouldConstrain(),
                            h = d ? p : p && m,
                            g = h && !a.pointerDown();
                        g && c.stop();
                        const v = n.get() * f + i.get() * (1 - f);
                        o.set(v),
                            d && (r.loop(t.direction()), s.loop()),
                            e.to(o.get()),
                            g && l.emit("settle"),
                            h || l.emit("scroll");
                    })(It, t)
            ),
            yt = ft[mt.get()],
            St = M(yt),
            bt = M(yt),
            Et = M(yt),
            wt = M(yt),
            xt = (function (t, e, n, o, s) {
                let a = 0,
                    c = 0,
                    l = s,
                    u = 0.68,
                    d = t.get(),
                    f = 0;
                function p(t) {
                    return (l = t), h;
                }
                function m(t) {
                    return (u = t), h;
                }
                const h = {
                    direction: function () {
                        return c;
                    },
                    duration: function () {
                        return l;
                    },
                    velocity: function () {
                        return a;
                    },
                    seek: function () {
                        const e = o.get() - t.get();
                        let i = 0;
                        return (
                            l
                                ? (n.set(t), (a += e / l), (a *= u), (d += a), t.add(a), (i = d - f))
                                : ((a = 0), n.set(o), t.set(o), (i = e)),
                            (c = r(i)),
                            (f = d),
                            h
                        );
                    },
                    settled: function () {
                        return i(o.get() - e.get()) < 0.001;
                    },
                    useBaseFriction: function () {
                        return m(0.68);
                    },
                    useBaseDuration: function () {
                        return p(s);
                    },
                    useFriction: m,
                    useDuration: p,
                };
                return h;
            })(St, Et, bt, wt, V),
            Mt = (function (t, e, n, o, s) {
                const { reachedAny: a, removeOffset: l, constrain: u } = o;
                function d(t) {
                    return t.concat().sort((t, e) => i(t) - i(e))[0];
                }
                function f(e, o) {
                    const i = [e, e + n, e - n];
                    if (!t) return e;
                    if (!o) return d(i);
                    const s = i.filter((t) => r(t) === o);
                    return s.length ? d(s) : c(i) - n;
                }
                return {
                    byDistance: function (n, o) {
                        const r = s.get() + n,
                            { index: c, distance: d } = (function (n) {
                                const o = t ? l(n) : u(n),
                                    r = e
                                        .map((t, e) => ({ diff: f(t - o, 0), index: e }))
                                        .sort((t, e) => i(t.diff) - i(e.diff)),
                                    { index: s } = r[0];
                                return { index: s, distance: o };
                            })(r),
                            p = !t && a(r);
                        return !o || p ? { index: c, distance: n } : { index: c, distance: n + f(e[c] - d, 0) };
                    },
                    byIndex: function (t, n) {
                        return { index: t, distance: f(e[t] - s.get(), n) };
                    },
                    shortcut: f,
                };
            })(C, ft, lt, pt, wt),
            Tt = (function (t, e, n, o, i, r, s) {
                function a(i) {
                    const a = i.distance,
                        c = i.index !== e.get();
                    r.add(a),
                        a && (o.duration() ? t.start() : (t.update(), t.render(1), t.update())),
                        c && (n.set(e.get()), e.set(i.index), s.emit("select"));
                }
                return {
                    distance: function (t, e) {
                        a(i.byDistance(t, e));
                    },
                    index: function (t, n) {
                        const o = e.clone().set(t);
                        a(i.byIndex(o.get(), n));
                    },
                };
            })(vt, mt, ht, xt, Mt, wt, F),
            Lt = (function (t) {
                const { max: e, length: n } = t;
                return {
                    get: function (t) {
                        return n ? (t - e) / -n : 0;
                    },
                };
            })(pt),
            At = h(),
            Ot = O(n, o, F, H),
            { slideRegistry: Dt } = (function (t, e, n, o, i, r) {
                const { groupSlides: s } = i,
                    { min: a, max: f } = o;
                return {
                    slideRegistry: (function () {
                        const o = s(r),
                            i = !t || "keepSnaps" === e;
                        return 1 === n.length
                            ? [r]
                            : i
                              ? o
                              : o.slice(a, f).map((t, e, n) => {
                                    const o = !e,
                                        i = u(n, e);
                                    return o ? d(c(n[0]) + 1) : i ? d(l(r) - c(n)[0] + 1, c(n)[0]) : t;
                                });
                    })(),
                };
            })(tt, q, ft, dt, st, gt),
            Ft = x(t, o, Dt, Tt, xt, At, F, U),
            It = {
                ownerDocument: f,
                ownerWindow: p,
                eventHandler: F,
                containerRect: K,
                slideRects: G,
                animation: vt,
                axis: Y,
                dragHandler: y(Y, t, f, p, wt, S(Y, p), St, vt, Tt, xt, Mt, mt, F, Q, _, z, R, 0.68, X),
                eventStore: At,
                percentOfView: Q,
                index: mt,
                indexPrevious: ht,
                limit: pt,
                location: St,
                offsetLocation: Et,
                previousLocation: bt,
                options: m,
                resizeHandler: b(n, F, p, o, Y, j, $),
                scrollBody: xt,
                scrollBounds: E(pt, Et, wt, xt, Q),
                scrollLooper: w(lt, pt, Et, [St, Et, bt, wt]),
                scrollProgress: Lt,
                scrollSnapList: ft.map(Lt.get),
                scrollSnaps: ft,
                scrollTarget: Mt,
                scrollTo: Tt,
                slideLooper: L(Y, J, lt, nt, ot, at, ft, Et, o),
                slideFocus: Ft,
                slidesHandler: A(n, F, W),
                slidesInView: Ot,
                slideIndexes: gt,
                slideRegistry: Dt,
                slidesToScroll: st,
                target: wt,
                translate: T(Y, n),
            };
        return It;
    }
    const I = {
        align: "center",
        axis: "x",
        container: null,
        slides: null,
        containScroll: "trimSnaps",
        direction: "ltr",
        slidesToScroll: 1,
        inViewThreshold: 0,
        breakpoints: {},
        dragFree: !1,
        dragThreshold: 10,
        loop: !1,
        skipSnaps: !1,
        duration: 25,
        startIndex: 0,
        active: !0,
        watchDrag: !0,
        watchResize: !0,
        watchSlides: !0,
        watchFocus: !0,
    };
    function N(t) {
        function e(t, e) {
            return p(t, e || {});
        }
        const n = {
            mergeOptions: e,
            optionsAtMedia: function (n) {
                const o = n.breakpoints || {},
                    i = f(o)
                        .filter((e) => t.matchMedia(e).matches)
                        .map((t) => o[t])
                        .reduce((t, n) => e(t, n), {});
                return e(n, i);
            },
            optionsMediaQueries: function (e) {
                return e
                    .map((t) => f(t.breakpoints || {}))
                    .reduce((t, e) => t.concat(e), [])
                    .map(t.matchMedia);
            },
        };
        return n;
    }
    function P(t, n, o) {
        const i = t.ownerDocument,
            r = i.defaultView,
            s = N(r),
            a = (function (t) {
                let e = [];
                return {
                    init: function (n, o) {
                        return (
                            (e = o.filter(({ options: e }) => !1 !== t.optionsAtMedia(e).active)),
                            e.forEach((e) => e.init(n, t)),
                            o.reduce((t, e) => Object.assign(t, { [e.name]: e }), {})
                        );
                    },
                    destroy: function () {
                        e = e.filter((t) => t.destroy());
                    },
                };
            })(s),
            c = h(),
            l = (function () {
                let t,
                    e = {};
                function n(t) {
                    return e[t] || [];
                }
                const o = {
                    init: function (e) {
                        t = e;
                    },
                    emit: function (e) {
                        return n(e).forEach((n) => n(t, e)), o;
                    },
                    off: function (t, i) {
                        return (e[t] = n(t).filter((t) => t !== i)), o;
                    },
                    on: function (t, i) {
                        return (e[t] = n(t).concat([i])), o;
                    },
                    clear: function () {
                        e = {};
                    },
                };
                return o;
            })(),
            { mergeOptions: u, optionsAtMedia: d, optionsMediaQueries: f } = s,
            { on: p, off: m, emit: g } = l,
            v = O;
        let y,
            S,
            b,
            E,
            w = !1,
            x = u(I, P.globalOptions),
            M = u(x),
            T = [];
        function L(e) {
            const n = F(t, b, E, i, r, e, l);
            return e.loop && !n.slideLooper.canLoop() ? L(Object.assign({}, e, { loop: !1 })) : n;
        }
        function A(n, o) {
            w ||
                ((x = u(x, n)),
                (M = d(x)),
                (T = o || T),
                (function () {
                    const { container: n, slides: o } = M,
                        i = e(n) ? t.querySelector(n) : n;
                    b = i || t.children[0];
                    const r = e(o) ? b.querySelectorAll(o) : o;
                    E = [].slice.call(r || b.children);
                })(),
                (y = L(M)),
                f([x, ...T.map(({ options: t }) => t)]).forEach((t) => c.add(t, "change", O)),
                M.active &&
                    (y.translate.to(y.location.get()),
                    y.animation.init(),
                    y.slidesInView.init(),
                    y.slideFocus.init(V),
                    y.eventHandler.init(V),
                    y.resizeHandler.init(V),
                    y.slidesHandler.init(V),
                    y.options.loop && y.slideLooper.loop(),
                    b.offsetParent && E.length && y.dragHandler.init(V),
                    (S = a.init(V, T))));
        }
        function O(t, e) {
            const n = C();
            D(), A(u({ startIndex: n }, t), e), l.emit("reInit");
        }
        function D() {
            y.dragHandler.destroy(),
                y.eventStore.clear(),
                y.translate.clear(),
                y.slideLooper.clear(),
                y.resizeHandler.destroy(),
                y.slidesHandler.destroy(),
                y.slidesInView.destroy(),
                y.animation.destroy(),
                a.destroy(),
                c.clear();
        }
        function k(t, e, n) {
            M.active &&
                !w &&
                (y.scrollBody.useBaseFriction().useDuration(!0 === e ? 0 : M.duration), y.scrollTo.index(t, n || 0));
        }
        function C() {
            return y.index.get();
        }
        const V = {
            canScrollNext: function () {
                return y.index.add(1).get() !== C();
            },
            canScrollPrev: function () {
                return y.index.add(-1).get() !== C();
            },
            containerNode: function () {
                return b;
            },
            internalEngine: function () {
                return y;
            },
            destroy: function () {
                w || ((w = !0), c.clear(), D(), l.emit("destroy"), l.clear());
            },
            off: m,
            on: p,
            emit: g,
            plugins: function () {
                return S;
            },
            previousScrollSnap: function () {
                return y.indexPrevious.get();
            },
            reInit: v,
            rootNode: function () {
                return t;
            },
            scrollNext: function (t) {
                k(y.index.add(1).get(), t, -1);
            },
            scrollPrev: function (t) {
                k(y.index.add(-1).get(), t, 1);
            },
            scrollProgress: function () {
                return y.scrollProgress.get(y.offsetLocation.get());
            },
            scrollSnapList: function () {
                return y.scrollSnapList;
            },
            scrollTo: k,
            selectedScrollSnap: C,
            slideNodes: function () {
                return E;
            },
            slidesInView: function () {
                return y.slidesInView.get();
            },
            slidesNotInView: function () {
                return y.slidesInView.get(!1);
            },
        };
        return A(n, o), setTimeout(() => l.emit("init"), 0), V;
    }
    return (P.globalOptions = void 0), P;
}),
    (function (t, e) {
        "object" == typeof exports && "undefined" != typeof module
            ? (module.exports = e())
            : "function" == typeof define && define.amd
              ? define(e)
              : ((t = "undefined" != typeof globalThis ? globalThis : t || self).EmblaCarouselAutoHeight = e());
    })(this, function () {
        "use strict";
        function t(t = {}) {
            let e,
                n = [];
            const o = ["select", "slideFocus"];
            function i() {
                const { slideRegistry: t } = e.internalEngine(),
                    o = t[e.selectedScrollSnap()];
                return o ? o.map((t) => n[t]).reduce((t, e) => Math.max(t, e), 0) : null;
            }
            function r() {
                null !== i() && (e.containerNode().style.height = `${i()}px`);
            }
            return {
                name: "autoHeight",
                options: t,
                init: function (t) {
                    e = t;
                    const {
                        options: { axis: i },
                        slideRects: s,
                    } = e.internalEngine();
                    "y" !== i && ((n = s.map((t) => t.height)), o.forEach((t) => e.on(t, r)), r());
                },
                destroy: function () {
                    o.forEach((t) => e.off(t, r));
                    const t = e.containerNode();
                    (t.style.height = ""), t.getAttribute("style") || t.removeAttribute("style");
                },
            };
        }
        return (t.globalOptions = void 0), t;
    }),
    (function (t, e) {
        "object" == typeof exports && "undefined" != typeof module
            ? (module.exports = e())
            : "function" == typeof define && define.amd
              ? define(e)
              : ((t = "undefined" != typeof globalThis ? globalThis : t || self).EmblaCarouselAutoScroll = e());
    })(this, function () {
        "use strict";
        const t = {
            direction: "forward",
            speed: 2,
            startDelay: 1e3,
            active: !0,
            breakpoints: {},
            playOnInit: !0,
            stopOnFocusIn: !0,
            stopOnInteraction: !0,
            stopOnMouseEnter: !1,
            rootNode: null,
        };
        function e(n = {}) {
            let o,
                i,
                r,
                s,
                a,
                c = 0,
                l = !1,
                u = !1;
            function d() {
                if (r) return;
                if (l) return;
                i.emit("autoScroll:play");
                const t = i.internalEngine(),
                    { ownerWindow: e } = t;
                (c = e.setTimeout(() => {
                    (t.scrollBody = (function (t) {
                        const {
                                location: e,
                                previousLocation: n,
                                offsetLocation: r,
                                target: s,
                                scrollTarget: a,
                                index: c,
                                indexPrevious: l,
                                limit: { reachedMin: u, reachedMax: d, constrain: p },
                                options: { loop: m },
                            } = t,
                            h = "forward" === o.direction ? -1 : 1,
                            g = () => w;
                        let v = 0,
                            y = 0,
                            S = e.get(),
                            b = 0,
                            E = !1;
                        const w = {
                            direction: () => y,
                            duration: () => -1,
                            velocity: () => v,
                            settled: () => E,
                            seek: function () {
                                let t = 0;
                                n.set(e),
                                    (v = h * o.speed),
                                    (S += v),
                                    e.add(v),
                                    s.set(e),
                                    (t = S - b),
                                    (y = Math.sign(t)),
                                    (b = S);
                                const g = a.byDistance(0, !1).index;
                                c.get() !== g && (l.set(c.get()), c.set(g), i.emit("select"));
                                const x = "forward" === o.direction ? u(r.get()) : d(r.get());
                                if (!m && x) {
                                    E = !0;
                                    const t = p(e.get());
                                    e.set(t), s.set(e), f();
                                }
                                return w;
                            },
                            useBaseFriction: g,
                            useBaseDuration: g,
                            useFriction: g,
                            useDuration: g,
                        };
                        return w;
                    })(t)),
                        t.animation.start();
                }, s)),
                    (l = !0);
            }
            function f() {
                if (r) return;
                if (!l) return;
                i.emit("autoScroll:stop");
                const t = i.internalEngine(),
                    { ownerWindow: e } = t;
                (t.scrollBody = a), e.clearTimeout(c), (c = 0), (l = !1);
            }
            function p() {
                u || f();
            }
            function m() {
                u || y();
            }
            function h() {
                (u = !0), f();
            }
            function g() {
                (u = !1), d();
            }
            function v() {
                i.off("settle", v), d();
            }
            function y() {
                i.on("settle", v);
            }
            return {
                name: "autoScroll",
                options: n,
                init: function (c, l) {
                    i = c;
                    const { mergeOptions: u, optionsAtMedia: v } = l,
                        y = u(t, e.globalOptions),
                        S = u(y, n);
                    if (((o = v(S)), i.scrollSnapList().length <= 1)) return;
                    (s = o.startDelay), (r = !1), (a = i.internalEngine().scrollBody);
                    const { eventStore: b } = i.internalEngine(),
                        E = !!i.internalEngine().options.watchDrag,
                        w = (function (t, e) {
                            const n = t.rootNode();
                            return (e && e(n)) || n;
                        })(i, o.rootNode);
                    E && i.on("pointerDown", p),
                        E && !o.stopOnInteraction && i.on("pointerUp", m),
                        o.stopOnMouseEnter && b.add(w, "mouseenter", h),
                        o.stopOnMouseEnter && !o.stopOnInteraction && b.add(w, "mouseleave", g),
                        o.stopOnFocusIn && i.on("slideFocusStart", f),
                        o.stopOnFocusIn && !o.stopOnInteraction && b.add(i.containerNode(), "focusout", d),
                        o.playOnInit && d();
                },
                destroy: function () {
                    i.off("pointerDown", p).off("pointerUp", m).off("slideFocusStart", f).off("settle", v),
                        f(),
                        (r = !0),
                        (l = !1);
                },
                play: function (t) {
                    void 0 !== t && (s = t), d();
                },
                stop: function () {
                    l && f();
                },
                reset: function () {
                    l && (f(), y());
                },
                isPlaying: function () {
                    return l;
                },
            };
        }
        return (e.globalOptions = void 0), e;
    }),
    (function (t, e) {
        "object" == typeof exports && "undefined" != typeof module
            ? (module.exports = e())
            : "function" == typeof define && define.amd
              ? define(e)
              : ((t = "undefined" != typeof globalThis ? globalThis : t || self).EmblaCarouselAutoplay = e());
    })(this, function () {
        "use strict";
        const t = {
            active: !0,
            breakpoints: {},
            delay: 4e3,
            jump: !1,
            playOnInit: !0,
            stopOnFocusIn: !0,
            stopOnInteraction: !0,
            stopOnMouseEnter: !1,
            stopOnLastSnap: !1,
            rootNode: null,
        };
        function e(n = {}) {
            let o,
                i,
                r,
                s,
                a = null,
                c = 0,
                l = !1,
                u = !1,
                d = !1,
                f = !1;
            function p() {
                r ||
                    (g()
                        ? (d = !0)
                        : (l || i.emit("autoplay:play"),
                          (function () {
                              const { ownerWindow: t } = i.internalEngine();
                              t.clearTimeout(c),
                                  (c = t.setTimeout(E, s[i.selectedScrollSnap()])),
                                  (a = new Date().getTime()),
                                  i.emit("autoplay:timerset");
                          })(),
                          (l = !0)));
            }
            function m() {
                r ||
                    (l && i.emit("autoplay:stop"),
                    (function () {
                        const { ownerWindow: t } = i.internalEngine();
                        t.clearTimeout(c), (c = 0), (a = null), i.emit("autoplay:timerstopped");
                    })(),
                    (l = !1));
            }
            function h() {
                if (g()) return (d = l), m();
                d && p();
            }
            function g() {
                const { ownerDocument: t } = i.internalEngine();
                return "hidden" === t.visibilityState;
            }
            function v() {
                u || m();
            }
            function y() {
                u || p();
            }
            function S() {
                (u = !0), m();
            }
            function b() {
                (u = !1), p();
            }
            function E() {
                const { index: t } = i.internalEngine(),
                    e = t.clone().add(1).get(),
                    n = i.scrollSnapList().length - 1,
                    r = o.stopOnLastSnap && e === n;
                if ((i.canScrollNext() ? i.scrollNext(f) : i.scrollTo(0, f), i.emit("autoplay:select"), r)) return m();
                p();
            }
            return {
                name: "autoplay",
                options: n,
                init: function (a, c) {
                    i = a;
                    const { mergeOptions: l, optionsAtMedia: u } = c,
                        d = l(t, e.globalOptions),
                        g = l(d, n);
                    if (((o = u(g)), i.scrollSnapList().length <= 1)) return;
                    (f = o.jump),
                        (r = !1),
                        (s = (function (t, e) {
                            const n = t.scrollSnapList();
                            return "number" == typeof e ? n.map(() => e) : e(n, t);
                        })(i, o.delay));
                    const { eventStore: E, ownerDocument: w } = i.internalEngine(),
                        x = !!i.internalEngine().options.watchDrag,
                        M = (function (t, e) {
                            const n = t.rootNode();
                            return (e && e(n)) || n;
                        })(i, o.rootNode);
                    E.add(w, "visibilitychange", h),
                        x && i.on("pointerDown", v),
                        x && !o.stopOnInteraction && i.on("pointerUp", y),
                        o.stopOnMouseEnter && E.add(M, "mouseenter", S),
                        o.stopOnMouseEnter && !o.stopOnInteraction && E.add(M, "mouseleave", b),
                        o.stopOnFocusIn && i.on("slideFocusStart", m),
                        o.stopOnFocusIn && !o.stopOnInteraction && E.add(i.containerNode(), "focusout", p),
                        o.playOnInit && p();
                },
                destroy: function () {
                    i.off("pointerDown", v).off("pointerUp", y).off("slideFocusStart", m), m(), (r = !0), (l = !1);
                },
                play: function (t) {
                    void 0 !== t && (f = t), p();
                },
                stop: function () {
                    l && m();
                },
                reset: function () {
                    l && p();
                },
                isPlaying: function () {
                    return l;
                },
                timeUntilNext: function () {
                    return a ? s[i.selectedScrollSnap()] - (new Date().getTime() - a) : null;
                },
            };
        }
        return (e.globalOptions = void 0), e;
    }),
    (function (t, e) {
        "object" == typeof exports && "undefined" != typeof module
            ? (module.exports = e())
            : "function" == typeof define && define.amd
              ? define(e)
              : ((t = "undefined" != typeof globalThis ? globalThis : t || self).EmblaCarouselClassNames = e());
    })(this, function () {
        "use strict";
        const t = {
            active: !0,
            breakpoints: {},
            snapped: "is-snapped",
            inView: "is-in-view",
            draggable: "is-draggable",
            dragging: "is-dragging",
            loop: "is-loop",
        };
        function e(t) {
            return (Array.isArray(t) ? t : [t]).filter(Boolean);
        }
        function n(t, e) {
            t && e.length && t.classList.remove(...e);
        }
        function o(t, e) {
            t && e.length && t.classList.add(...e);
        }
        function i(r = {}) {
            let s,
                a,
                c,
                l,
                u = [],
                d = [];
            const f = ["select"],
                p = ["pointerDown", "pointerUp"],
                m = ["slidesInView"],
                h = { snapped: [], inView: [], draggable: [], dragging: [], loop: [] };
            function g(t, e) {
                ("pointerDown" === e ? o : n)(c, h.dragging);
            }
            function v(t = [], e = [], i) {
                const r = e.map((t) => l[t]),
                    s = t.map((t) => l[t]);
                return r.forEach((t) => n(t, i)), s.forEach((t) => o(t, i)), t;
            }
            function y() {
                const { slideRegistry: t } = a.internalEngine(),
                    e = t[a.selectedScrollSnap()];
                u = v(e, u, h.snapped);
            }
            function S() {
                const t = a.slidesInView();
                d = v(t, d, h.inView);
            }
            return {
                name: "classNames",
                options: r,
                init: function (n, u) {
                    a = n;
                    const { mergeOptions: d, optionsAtMedia: v } = u,
                        b = d(t, i.globalOptions),
                        E = d(b, r);
                    (s = v(E)), (c = a.rootNode()), (l = a.slideNodes());
                    const { watchDrag: w, loop: x } = a.internalEngine().options,
                        M = !!w;
                    s.loop && x && ((h.loop = e(s.loop)), o(c, h.loop)),
                        s.draggable && M && ((h.draggable = e(s.draggable)), o(c, h.draggable)),
                        s.dragging && ((h.dragging = e(s.dragging)), p.forEach((t) => a.on(t, g))),
                        s.snapped && ((h.snapped = e(s.snapped)), f.forEach((t) => a.on(t, y)), y()),
                        s.inView && ((h.inView = e(s.inView)), m.forEach((t) => a.on(t, S)), S());
                },
                destroy: function () {
                    p.forEach((t) => a.off(t, g)),
                        f.forEach((t) => a.off(t, y)),
                        m.forEach((t) => a.off(t, S)),
                        n(c, h.loop),
                        n(c, h.draggable),
                        n(c, h.dragging),
                        v([], u, h.snapped),
                        v([], d, h.inView),
                        Object.keys(h).forEach((t) => {
                            h[t] = [];
                        });
                },
            };
        }
        return (i.globalOptions = void 0), i;
    }),
    (function (t, e) {
        "object" == typeof exports && "undefined" != typeof module
            ? (module.exports = e())
            : "function" == typeof define && define.amd
              ? define(e)
              : ((t = "undefined" != typeof globalThis ? globalThis : t || self).EmblaCarouselFade = e());
    })(this, function () {
        "use strict";
        function t(t, e, n) {
            return Math.min(Math.max(t, e), n);
        }
        function e(t) {
            return "number" == typeof t && !isNaN(t);
        }
        function n(n = {}) {
            let o,
                i,
                r,
                s,
                a = [],
                c = 0,
                l = 0,
                u = 0,
                d = !1;
            function f() {
                v(o.selectedScrollSnap(), 1);
            }
            function p() {
                d = !1;
            }
            function m() {
                (d = !1), (c = 0), (l = 0);
            }
            function h() {
                const t = o.internalEngine().scrollBody.duration();
                (l = t ? 0 : 1), (d = !0), t || f();
            }
            function g(t) {
                const { scrollSnaps: n, location: i, target: r } = o.internalEngine();
                !e(t) || a[t] < 0.5 || (i.set(n[t]), r.set(i));
            }
            function v(e, n) {
                o.scrollSnapList().forEach((i, r) => {
                    const s = Math.abs(n),
                        l = a[r],
                        f = r === e,
                        p = t(f ? l + s : l - s, 0, 1);
                    a[r] = p;
                    const m = f && d,
                        h = o.previousScrollSnap();
                    m && (a[h] = 1 - p),
                        f &&
                            (function (t, e) {
                                const { index: n, dragHandler: i, scrollSnaps: r } = o.internalEngine(),
                                    s = i.pointerDown(),
                                    a = 1 / (r.length - 1);
                                let l = t,
                                    d = s ? o.selectedScrollSnap() : o.previousScrollSnap();
                                if (s && l === d) {
                                    const t = -1 * Math.sign(c);
                                    (l = d), (d = n.clone().set(d).add(t).get());
                                }
                                u = d * a + (l - d) * a * e;
                            })(e, p),
                        (function (t) {
                            const e = o.internalEngine().slideRegistry[t],
                                { scrollSnaps: n, containerRect: i } = o.internalEngine(),
                                r = a[t];
                            e.forEach((e) => {
                                const s = o.slideNodes()[e].style,
                                    a = parseFloat(r.toFixed(2)),
                                    c = a > 0,
                                    l = (function (t) {
                                        const { axis: e } = o.internalEngine();
                                        return `translate${e.scroll.toUpperCase()}(${e.direction(t)}px)`;
                                    })(c ? n[t] : i.width + 2);
                                c && (s.transform = l),
                                    (s.opacity = a.toString()),
                                    (s.pointerEvents = r > 0.5 ? "auto" : "none"),
                                    c || (s.transform = l);
                            });
                        })(r);
                });
            }
            function y() {
                const { dragHandler: t, index: e, scrollBody: n } = o.internalEngine(),
                    i = o.selectedScrollSnap();
                if (!t.pointerDown()) return i;
                const r = Math.sign(n.velocity()),
                    s = Math.sign(c),
                    a = e
                        .clone()
                        .set(i)
                        .add(-1 * r)
                        .get();
                return r && s ? (s === r ? a : i) : null;
            }
            function S() {
                const { target: t, location: n } = o.internalEngine(),
                    r = t.get() - n.get(),
                    s = Math.abs(r) >= 1,
                    u = y(),
                    d = !e(u);
                return (
                    (function (t) {
                        const { dragHandler: n, scrollBody: o } = t.internalEngine(),
                            r = n.pointerDown(),
                            s = o.velocity(),
                            u = o.duration(),
                            d = y(),
                            f = !e(d);
                        if (r) {
                            if (!s) return;
                            (c += s), (l = Math.abs(s / i)), g(d);
                        }
                        if (!r) {
                            if (!u || f) return;
                            (l += (1 - a[d]) / u), (l *= 0.68);
                        }
                        f || v(d, l);
                    })(o),
                    !d && !s && a[u] > 0.999
                );
            }
            function b() {
                return u;
            }
            return {
                name: "fade",
                options: n,
                init: function (e) {
                    o = e;
                    const n = o.selectedScrollSnap(),
                        { scrollBody: c, containerRect: l, axis: u } = o.internalEngine(),
                        g = u.measureSize(l);
                    (i = t(0.75 * g, 200, 500)),
                        (d = !1),
                        (a = o.scrollSnapList().map((t, e) => (e === n ? 1 : 0))),
                        (r = c.settled),
                        (s = o.scrollProgress),
                        (c.settled = S),
                        (o.scrollProgress = b),
                        o.on("select", h).on("slideFocus", f).on("pointerDown", m).on("pointerUp", p),
                        (function () {
                            const { translate: t, slideLooper: e } = o.internalEngine();
                            t.clear(),
                                t.toggleActive(!1),
                                e.loopPoints.forEach(({ translate: t }) => {
                                    t.clear(), t.toggleActive(!1);
                                });
                        })(),
                        f();
                },
                destroy: function () {
                    const { scrollBody: t } = o.internalEngine();
                    (t.settled = r),
                        (o.scrollProgress = s),
                        o.off("select", h).off("slideFocus", f).off("pointerDown", m).off("pointerUp", p),
                        o.slideNodes().forEach((t) => {
                            const e = t.style;
                            (e.opacity = ""),
                                (e.transform = ""),
                                (e.pointerEvents = ""),
                                t.getAttribute("style") || t.removeAttribute("style");
                        });
                },
            };
        }
        return (n.globalOptions = void 0), n;
    }),
    (function (t, e) {
        "object" == typeof exports && "undefined" != typeof module
            ? (module.exports = e())
            : "function" == typeof define && define.amd
              ? define(e)
              : ((t = t || self).EmblaCarouselWheelGestures = e());
    })(this, function () {
        "use strict";
        function t() {
            return (t =
                Object.assign ||
                function (t) {
                    for (var e = 1; e < arguments.length; e++) {
                        var n = arguments[e];
                        for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
                    }
                    return t;
                }).apply(this, arguments);
        }
        function e(t, e) {
            if (t.length !== e.length) throw new Error("vectors must be same length");
            return t.map(function (t, n) {
                return t + e[n];
            });
        }
        function n(t) {
            return Math.max.apply(Math, t.map(Math.abs));
        }
        function o(t) {
            return (
                Object.freeze(t),
                Object.values(t).forEach(function (t) {
                    null === t || "object" != typeof t || Object.isFrozen(t) || o(t);
                }),
                t
            );
        }
        var i = [1, 18, ("undefined" != typeof window && window.innerHeight) || 800],
            r = [-1, -1, -1],
            s = o({ preventWheelAction: !0, reverseSign: [!0, !0, !1] }),
            a = {
                active: !0,
                breakpoints: {},
                wheelDraggingClass: "is-wheel-dragging",
                forceWheelAxis: void 0,
                target: void 0,
            };
        function c(l) {
            var u;
            void 0 === l && (l = {});
            var d = function () {};
            return {
                name: "wheelGestures",
                options: l,
                init: function (f, p) {
                    var m,
                        h,
                        g = p.mergeOptions,
                        v = p.optionsAtMedia,
                        y = g(a, c.globalOptions),
                        S = g(y, l);
                    u = v(S);
                    var b,
                        E = f.internalEngine(),
                        w = null != (m = u.target) ? m : f.containerNode().parentNode,
                        x = null != (h = u.forceWheelAxis) ? h : E.options.axis,
                        M = (function (a) {
                            void 0 === a && (a = {});
                            var c,
                                l,
                                u,
                                d = (function () {
                                    var t = {};
                                    function e(e, n) {
                                        t[e] = (t[e] || []).filter(function (t) {
                                            return t !== n;
                                        });
                                    }
                                    return o({
                                        on: function (n, o) {
                                            return (
                                                (t[n] = (t[n] || []).concat(o)),
                                                function () {
                                                    return e(n, o);
                                                }
                                            );
                                        },
                                        off: e,
                                        dispatch: function (e, n) {
                                            e in t &&
                                                t[e].forEach(function (t) {
                                                    return t(n);
                                                });
                                        },
                                    });
                                })(),
                                f = d.on,
                                p = d.off,
                                m = d.dispatch,
                                h = s,
                                g = {
                                    isStarted: !1,
                                    isStartPublished: !1,
                                    isMomentum: !1,
                                    startTime: 0,
                                    lastAbsDelta: 1 / 0,
                                    axisMovement: [0, 0, 0],
                                    axisVelocity: [0, 0, 0],
                                    accelerationFactors: [],
                                    scrollPoints: [],
                                    scrollPointsToMerge: [],
                                    willEndTimeout: 400,
                                },
                                v = !1,
                                y = function (t) {
                                    Array.isArray(t)
                                        ? t.forEach(function (t) {
                                              return E(t);
                                          })
                                        : E(t);
                                },
                                S = function (e) {
                                    return (
                                        void 0 === e && (e = {}),
                                        Object.values(e).some(function (t) {
                                            return null == t;
                                        })
                                            ? h
                                            : (h = o(t({}, s, h, e)))
                                    );
                                },
                                b = function (n) {
                                    var o = t(
                                        {
                                            event: c,
                                            isStart: !1,
                                            isEnding: !1,
                                            isMomentumCancel: !1,
                                            isMomentum: g.isMomentum,
                                            axisDelta: [0, 0, 0],
                                            axisVelocity: g.axisVelocity,
                                            axisMovement: g.axisMovement,
                                            get axisMovementProjection() {
                                                return e(
                                                    o.axisMovement,
                                                    o.axisVelocity.map(function (t) {
                                                        return void 0 === e && (e = 0.996), (t * e) / (1 - e);
                                                        var e;
                                                    })
                                                );
                                            },
                                        },
                                        n
                                    );
                                    m("wheel", t({}, o, { previous: l })), (l = o);
                                },
                                E = function (o) {
                                    var s,
                                        a = (function (e) {
                                            return t({}, e, {
                                                axisDelta: e.axisDelta.map(function (t) {
                                                    return Math.min(Math.max(-700, t), 700);
                                                }),
                                            });
                                        })(
                                            (function (e, n) {
                                                if (!n) return e;
                                                var o =
                                                    !0 === n
                                                        ? r
                                                        : n.map(function (t) {
                                                              return t ? -1 : 1;
                                                          });
                                                return t({}, e, {
                                                    axisDelta: e.axisDelta.map(function (t, e) {
                                                        return t * o[e];
                                                    }),
                                                });
                                            })(
                                                {
                                                    timeStamp: (s = o).timeStamp,
                                                    axisDelta: [
                                                        s.deltaX * i[s.deltaMode],
                                                        s.deltaY * i[s.deltaMode],
                                                        (s.deltaZ || 0) * i[s.deltaMode],
                                                    ],
                                                },
                                                h.reverseSign
                                            )
                                        ),
                                        l = a.axisDelta,
                                        u = a.timeStamp,
                                        d = n(l);
                                    o.preventDefault &&
                                        (function (t, e) {
                                            var n = h.preventWheelAction,
                                                o = e[0],
                                                i = e[1],
                                                r = e[2];
                                            if ("boolean" == typeof n) return n;
                                            switch (n) {
                                                case "x":
                                                    return Math.abs(o) >= t;
                                                case "y":
                                                    return Math.abs(i) >= t;
                                                case "z":
                                                    return Math.abs(r) >= t;
                                                default:
                                                    return !1;
                                            }
                                        })(d, l) &&
                                        o.preventDefault(),
                                        g.isStarted
                                            ? g.isMomentum && d > Math.max(2, 2 * g.lastAbsDelta) && (I(!0), D())
                                            : D(),
                                        0 === d && Object.is && Object.is(o.deltaX, -0)
                                            ? (v = !0)
                                            : ((c = o),
                                              (g.axisMovement = e(g.axisMovement, l)),
                                              (g.lastAbsDelta = d),
                                              g.scrollPointsToMerge.push({ axisDelta: l, timeStamp: u }),
                                              w(),
                                              b({ axisDelta: l, isStart: !g.isStartPublished }),
                                              (g.isStartPublished = !0),
                                              F());
                                },
                                w = function () {
                                    var t;
                                    2 === g.scrollPointsToMerge.length
                                        ? (g.scrollPoints.unshift({
                                              axisDeltaSum: g.scrollPointsToMerge
                                                  .map(function (t) {
                                                      return t.axisDelta;
                                                  })
                                                  .reduce(e),
                                              timeStamp:
                                                  ((t = g.scrollPointsToMerge.map(function (t) {
                                                      return t.timeStamp;
                                                  })),
                                                  t.reduce(function (t, e) {
                                                      return t + e;
                                                  }) / t.length),
                                          }),
                                          M(),
                                          (g.scrollPointsToMerge.length = 0),
                                          (g.scrollPoints.length = 1),
                                          g.isMomentum || A())
                                        : g.isStartPublished || x();
                                },
                                x = function () {
                                    var t;
                                    g.axisVelocity = ((t = g.scrollPointsToMerge), t[t.length - 1]).axisDelta.map(
                                        function (t) {
                                            return t / g.willEndTimeout;
                                        }
                                    );
                                },
                                M = function () {
                                    var t = g.scrollPoints,
                                        e = t[0],
                                        n = t[1];
                                    if (n && e) {
                                        var o = e.timeStamp - n.timeStamp;
                                        if (!(o <= 0)) {
                                            var i = e.axisDeltaSum.map(function (t) {
                                                    return t / o;
                                                }),
                                                r = i.map(function (t, e) {
                                                    return t / (g.axisVelocity[e] || 1);
                                                });
                                            (g.axisVelocity = i), g.accelerationFactors.push(r), T(o);
                                        }
                                    }
                                },
                                T = function (t) {
                                    var e = 10 * Math.ceil(t / 10) * 1.2;
                                    g.isMomentum || (e = Math.max(100, 2 * e)),
                                        (g.willEndTimeout = Math.min(1e3, Math.round(e)));
                                },
                                L = function (t) {
                                    return 0 === t || (t <= 0.96 && t >= 0.6);
                                },
                                A = function () {
                                    if (g.accelerationFactors.length >= 5) {
                                        if (v && ((v = !1), n(g.axisVelocity) >= 0.2)) return void O();
                                        var t = g.accelerationFactors.slice(-5);
                                        t.every(function (t) {
                                            var e = !!t.reduce(function (t, e) {
                                                    return t && t < 1 && t === e ? 1 : 0;
                                                }),
                                                n = t.filter(L).length === t.length;
                                            return e || n;
                                        }) && O(),
                                            (g.accelerationFactors = t);
                                    }
                                },
                                O = function () {
                                    g.isMomentum = !0;
                                },
                                D = function () {
                                    ((g = {
                                        isStarted: !1,
                                        isStartPublished: !1,
                                        isMomentum: !1,
                                        startTime: 0,
                                        lastAbsDelta: 1 / 0,
                                        axisMovement: [0, 0, 0],
                                        axisVelocity: [0, 0, 0],
                                        accelerationFactors: [],
                                        scrollPoints: [],
                                        scrollPointsToMerge: [],
                                        willEndTimeout: 400,
                                    }).isStarted = !0),
                                        (g.startTime = Date.now()),
                                        (l = void 0),
                                        (v = !1);
                                },
                                F = function () {
                                    clearTimeout(u), (u = setTimeout(I, g.willEndTimeout));
                                },
                                I = function (t) {
                                    void 0 === t && (t = !1),
                                        g.isStarted &&
                                            (b(
                                                g.isMomentum && t
                                                    ? { isEnding: !0, isMomentumCancel: !0 }
                                                    : { isEnding: !0 }
                                            ),
                                            (g.isMomentum = !1),
                                            (g.isStarted = !1));
                                },
                                N = (function (t) {
                                    var e = [],
                                        n = function (n) {
                                            n.removeEventListener("wheel", t),
                                                (e = e.filter(function (t) {
                                                    return t !== n;
                                                }));
                                        };
                                    return o({
                                        observe: function (o) {
                                            return (
                                                o.addEventListener("wheel", t, { passive: !1 }),
                                                e.push(o),
                                                function () {
                                                    return n(o);
                                                }
                                            );
                                        },
                                        unobserve: n,
                                        disconnect: function () {
                                            e.forEach(n);
                                        },
                                    });
                                })(y),
                                P = N.observe,
                                k = N.unobserve,
                                C = N.disconnect;
                            return (
                                S(a),
                                o({
                                    on: f,
                                    off: p,
                                    observe: P,
                                    unobserve: k,
                                    disconnect: C,
                                    feedWheel: y,
                                    updateOptions: S,
                                })
                            );
                        })({ preventWheelAction: x, reverseSign: [!0, !0, !1] }),
                        T = M.observe(w),
                        L = M.on("wheel", function (t) {
                            var e = t.axisDelta,
                                n = e[0],
                                o = e[1],
                                i = "x" === x ? o : n,
                                r =
                                    (t.isEnding && !t.isMomentum) ||
                                    (t.isMomentum && t.previous && !t.previous.isMomentum);
                            Math.abs("x" === x ? n : o) > Math.abs(i) &&
                                !A &&
                                !t.isMomentum &&
                                (function (t) {
                                    try {
                                        I((b = new MouseEvent("mousedown", t.event)));
                                    } catch (t) {
                                        return d();
                                    }
                                    (A = !0),
                                        document.documentElement.addEventListener("mousemove", D, !0),
                                        document.documentElement.addEventListener("mouseup", D, !0),
                                        document.documentElement.addEventListener("mousedown", D, !0),
                                        u.wheelDraggingClass && w.classList.add(u.wheelDraggingClass);
                                })(t),
                                A &&
                                    (r
                                        ? (function (t) {
                                              (A = !1),
                                                  I(F("mouseup", t)),
                                                  O(),
                                                  u.wheelDraggingClass && w.classList.remove(u.wheelDraggingClass);
                                          })(t)
                                        : I(F("mousemove", t)));
                        }),
                        A = !1;
                    function O() {
                        document.documentElement.removeEventListener("mousemove", D, !0),
                            document.documentElement.removeEventListener("mouseup", D, !0),
                            document.documentElement.removeEventListener("mousedown", D, !0);
                    }
                    function D(t) {
                        A && t.isTrusted && t.stopImmediatePropagation();
                    }
                    function F(t, e) {
                        var n, o;
                        if (x === E.options.axis) {
                            var i = e.axisMovement;
                            (n = i[0]), (o = i[1]);
                        } else {
                            var r = e.axisMovement;
                            (o = r[0]), (n = r[1]);
                        }
                        if (!E.options.skipSnaps && !E.options.dragFree) {
                            var s = E.containerRect.width,
                                a = E.containerRect.height;
                            (n = n < 0 ? Math.max(n, -s) : Math.min(n, s)),
                                (o = o < 0 ? Math.max(o, -a) : Math.min(o, a));
                        }
                        return new MouseEvent(t, {
                            clientX: b.clientX + n,
                            clientY: b.clientY + o,
                            screenX: b.screenX + n,
                            screenY: b.screenY + o,
                            movementX: n,
                            movementY: o,
                            button: 0,
                            bubbles: !0,
                            cancelable: !0,
                            composed: !0,
                        });
                    }
                    function I(t) {
                        f.containerNode().dispatchEvent(t);
                    }
                    d = function () {
                        T(), L(), O();
                    };
                },
                destroy: function () {
                    return d();
                },
            };
        }
        return (c.globalOptions = void 0), c;
    });
class MivoSlider extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        (this.slider = null),
            (this.thumbSlider = null),
            (this.options = this.querySelector("[data-options]")),
            (this.thumbOptions = this.querySelector("[data-thumbs-options]")),
            (this.viewport = this.querySelector(".mivo-slider-viewport")),
            (this.thumbsViewport = this.querySelector(".mivo-thumbs-slider-viewport")),
            this.init(),
            document.addEventListener("shopify:section:load", (t) => this.init(t)),
            document.addEventListener("shopify:section:select", (t) => this.init(t)),
            document.addEventListener("shopify:block:select", (t) => this.init(t)),
            document.addEventListener("product-variant-updated", (t) => this.scroolTo(t)),
            document.addEventListener("product-quick-viewed", (t) => this.scroolTo(t));
    }
    scroolTo(t) {
        if (!this.classList.contains("product-gallery-slider")) return;
        const e = t?.detail?.selected;
        e && e.featured_media && e.featured_media.position && this.slider.scrollTo(e.featured_media.position - 1, 600);
    }
    toggleArrows(t, e, n) {
        const o = () => {
            t.canScrollPrev() ? e.removeAttribute("disabled") : e.setAttribute("disabled", "disabled"),
                t.canScrollNext() ? n.removeAttribute("disabled") : n.setAttribute("disabled", "disabled");
        };
        return t.on("select", o).on("init", o).on("reInit", o), n.removeAttribute("disabled");
    }
    addArrows(t, e, n) {
        const o = () => t.scrollPrev(),
            i = () => t.scrollNext();
        e.addEventListener("click", o, !1), n.addEventListener("click", i, !1);
        const r = this.toggleArrows(t, e, n);
        return () => {
            r(), e.removeEventListener("click", o, !1), n.removeEventListener("click", i, !1);
        };
    }
    addDots(t, e) {
        let n = [];
        const o = () => {
                (e.innerHTML = t
                    .scrollSnapList()
                    .map(() => '<span class="mivo-dot"></span>')
                    .join("")),
                    (n = e.querySelectorAll(".mivo-dot")),
                    n.forEach((e, n) => e.addEventListener("click", () => t.scrollTo(n), !1));
            },
            i = () => {
                const e = t.previousScrollSnap(),
                    o = t.selectedScrollSnap();
                n[e].classList.remove("selected"), n[o].classList.add("selected");
            };
        return t.on("init", o).on("reInit", o).on("init", i).on("reInit", i).on("select", i), () => (e.innerHTML = "");
    }
    addPagination(t, e) {
        let n, o;
        const i = () => {
            const e = t.slideNodes().length,
                i = t.selectedScrollSnap() + 1;
            (n.textContent = i), (o.textContent = e);
        };
        return (
            t
                .on("init", () => {
                    (e.innerHTML =
                        '\n\t\t\t\t<span class="mivo-pagination-current"></span>\n\t\t\t\t<span class="mivo-pagination-divider"> / </span>\n\t\t\t\t<span class="mivo-pagination-total"></span>\n\t\t\t'),
                        (n = e.querySelector(".mivo-pagination-current")),
                        (o = e.querySelector(".mivo-pagination-total")),
                        i();
                })
                .on("reInit", i)
                .on("select", i),
            () => (e.innerHTML = "")
        );
    }
    addThumbBtnsClickHandlers(t, e) {
        const n = e.slideNodes(),
            o = n.map((e, n) => () => t.scrollTo(n));
        return (
            n.forEach((t, e) => t.addEventListener("click", o[e], !1)),
            () => n.forEach((t, e) => t.removeEventListener("click", o[e], !1))
        );
    }
    addToggleThumbBtnsActive(t, e) {
        const n = e.slideNodes(),
            o = () => {
                e.scrollTo(t.selectedScrollSnap());
                const o = t.previousScrollSnap(),
                    i = t.selectedScrollSnap();
                n[o].classList.remove("selected"), n[i].classList.add("selected");
            };
        return (
            t.on("select", o),
            e.on("init", o),
            () => {
                const e = t.selectedScrollSnap();
                n[e].classList.remove("selected");
            }
        );
    }
    addLazyLoad(t) {
        const e = new Set(),
            n = t.slideNodes(),
            o = (o) => {
                if (e.has(o)) return;
                const i = n[o],
                    r = i?.querySelector(".mivo-slider-lazy-load-img");
                if (!r) return;
                const s = r.getAttribute("data-src");
                if (!s) return;
                (r.src = s), e.add(o);
                const a = () => {
                    r.removeEventListener("load", a),
                        i.classList.add("mivo-slider-lazy-load-has-loaded"),
                        requestAnimationFrame(() => {
                            t.reInit(), t.emit("resize");
                        });
                };
                r.complete && 0 !== r.naturalHeight ? a() : r.addEventListener("load", a);
            },
            i = () => {
                t.slidesInView(!0).forEach(o);
            };
        return (
            t.on("init", i),
            t.on("reInit", i),
            t.on("slidesInView", i),
            t.on("select", () => {
                const n = t.selectedScrollSnap();
                e.has(n) ? requestAnimationFrame(() => t.emit("resize")) : o(n);
            }),
            () => {}
        );
    }
    addLazyLoadForThumbnails(t) {
        const e = new Set(),
            n = this.thumbSlider.slideNodes(),
            o = (o) => {
                if (e.has(o)) return;
                const i = n[o],
                    r = i?.querySelector(".mivo-slider-lazy-load-img");
                if (!r) return;
                const s = r.getAttribute("data-src");
                if (!s) return;
                (r.src = s), e.add(o);
                const a = () => {
                    r.removeEventListener("load", a),
                        i.classList.add("mivo-slider-lazy-load-has-loaded"),
                        requestAnimationFrame(() => {
                            t.reInit(), t.emit("resize");
                        });
                };
                r.complete && 0 !== r.naturalHeight ? a() : r.addEventListener("load", a);
            },
            i = () => {
                this.thumbSlider.slidesInView(!0).forEach(o);
            };
        return (
            this.thumbSlider.on("init", i),
            this.thumbSlider.on("reInit", i),
            this.thumbSlider.on("slidesInView", i),
            this.thumbSlider.on("select", () => {
                const t = this.thumbSlider.selectedScrollSnap();
                e.has(t) ? requestAnimationFrame(() => this.thumbSlider.emit("resize")) : o(t);
            }),
            () => {}
        );
    }
    TWEEN_FACTOR_BASE = 0.3115;
    tweenFactor = 0;
    tweenNodes = [];
    numberWithinRange(t, e, n) {
        return Math.min(Math.max(t, e), n);
    }
    setTweenNodes(t) {
        this.tweenNodes = t.slideNodes().map((t) => t.querySelector(".mivo-slide-scale .product-card"));
    }
    setTweenFactor(t) {
        this.tweenFactor = this.TWEEN_FACTOR_BASE * t.scrollSnapList().length;
    }
    tweenScale = (t, e) => {
        const n = t.internalEngine(),
            o = t.scrollProgress(),
            i = t.slidesInView(),
            r = "scroll" === e;
        t.scrollSnapList().forEach((t, e) => {
            let s = t - o;
            n.slideRegistry[e].forEach((e) => {
                if (r && !i.includes(e)) return;
                n.options.loop &&
                    n.slideLooper.loopPoints.forEach((n) => {
                        const i = n.target();
                        if (e === n.index && 0 !== i) {
                            const e = Math.sign(i);
                            -1 === e && (s = t - (1 + o)), 1 === e && (s = t + (1 - o));
                        }
                    });
                const a = 1 - Math.abs(s * this.tweenFactor),
                    c = this.numberWithinRange(a, 0, 1).toString(),
                    l = this.tweenNodes[e];
                l && ((l.style.transform = `scale(${c})`), (l.style.transition = "transform 0.2s ease-out"));
            });
        });
    };
    setupTweenScale(t) {
        return (
            this.setTweenNodes(t),
            this.setTweenFactor(t),
            this.tweenScale(t),
            t
                .on("reInit", () => this.setTweenNodes(t))
                .on("reInit", () => this.setTweenFactor(t))
                .on("reInit", () => this.tweenScale(t))
                .on("scroll", () => this.tweenScale(t, "scroll"))
                .on("slideFocus", () => this.tweenScale(t, "slideFocus")),
            () => {
                this.tweenNodes.forEach((t) => t?.removeAttribute("style"));
            }
        );
    }
    STACK_TWEEN_FACTOR_BASE = 0.15;
    STACK_OVERLAP = 1;
    STACK_MAX_DEPTH = 2;
    STACK_MAX_ROTATE = 5;
    stackNodes = [];
    stackTweenFactor = 0;
    setStackNodes(t) {
        this.stackNodes = t.slideNodes().map((t) => t.querySelector(".mivo-slider-stack .mivo-slide-inner"));
    }
    setStackFactor(t) {
        this.stackTweenFactor = this.STACK_TWEEN_FACTOR_BASE * t.scrollSnapList().length;
    }
    stackEffect = (t) => {
        const e = t.internalEngine(),
            n = t.scrollProgress(),
            o = t.scrollSnapList(),
            i = o.length,
            r = i / 2,
            s = e.options.loop,
            a = n * i;
        o.forEach((t, o) => {
            const c = e.slideRegistry[o],
                l = t * i;
            c.forEach((o) => {
                let c = t - n,
                    u = l - a;
                s &&
                    (u > r && (u -= i),
                    u < -r && (u += i),
                    e.slideLooper.loopPoints.forEach((e) => {
                        const i = e.target();
                        if (o === e.index && 0 !== i) {
                            const e = Math.sign(i);
                            -1 === e && (c = t - (1 + n)), 1 === e && (c = t + (1 - n));
                        }
                    }));
                const d = Math.abs(u),
                    f = Math.sign(u),
                    p = d <= 1 ? d : 1 + 1 * (d - 1),
                    m = this.stackNodes[o];
                if (!m) return;
                const h = m.closest(".mivo-slide"),
                    g = h.getBoundingClientRect().width,
                    v = h.querySelector(".slide-content"),
                    y = -f * g * this.STACK_OVERLAP * p,
                    S = f * Math.min(d, 2) * this.STACK_MAX_ROTATE,
                    b = 1 - 0.03 * Math.min(d, this.STACK_MAX_DEPTH),
                    E = this.numberWithinRange(this.STACK_MAX_DEPTH - d, 0, 1),
                    w = this.numberWithinRange(1 - 0.2 * d, 0, 1),
                    x = 10 - Math.round(d);
                (h.style.zIndex = String(x)),
                    (h.style.opacity = String(E)),
                    (m.style.transform = `translateX(${y}px) rotate(${S}deg) scale(${b})`),
                    (v.style.opacity = String(w));
            });
        });
    };
    setupStack(t) {
        return (
            this.setStackNodes(t),
            this.setStackFactor(t),
            this.stackEffect(t),
            t
                .on("reInit", () => this.setStackNodes(t))
                .on("reInit", () => this.setStackFactor(t))
                .on("reInit", () => this.stackEffect(t))
                .on("scroll", () => this.stackEffect(t))
                .on("slideFocus", () => this.stackEffect(t)),
            () => {
                this.stackNodes.forEach((t) => t?.removeAttribute("style"));
            }
        );
    }
    init(t) {
        if (!this.options || !this.viewport || this.classList.contains("initialized")) {
            if (Shopify.designMode && t?.detail?.blockId) {
                let e = this.querySelector(`.mivo-slide[data-id=${t.detail.blockId}]`)?.getAttribute("data-index");
                e && this.slider.scrollTo(Number(e));
            }
            return;
        }
        let e = JSON.parse(this.options.content.textContent),
            n = [EmblaCarouselClassNames()];
        e.watchResize = (t, e) => {
            for (const n of e) {
                if (t.containerNode() === n.target) return !0;
                window.requestAnimationFrame(() => {
                    t.reInit(), t.emit("resize");
                });
                break;
            }
            return !1;
        };
        let o =
                this.querySelector(".mivo-thumbs-slider-wrapper .mivo-button-prev") ||
                this.querySelector(".mivo-arrows .mivo-button-prev") ||
                this.querySelector(".mivo-button-prev"),
            i =
                this.querySelector(".mivo-thumbs-slider-wrapper .mivo-button-next") ||
                this.querySelector(".mivo-arrows .mivo-button-next") ||
                this.querySelector(".mivo-button-next"),
            r = this.querySelector(e._dotsNode),
            s = this.querySelector(e._pagination);
        if (e._autoplay) {
            let t = {
                delay: Number(e._autoplay || 5e3),
                stopOnMouseEnter: !0,
                stopOnFocusIn: !0,
                stopOnInteraction: !1,
            };
            n.push(EmblaCarouselAutoplay(t));
        }
        if (e._autoscroll) {
            let t = {
                speed: Number(e._autoscroll_speed || 2),
                startDelay: 0,
                stopOnMouseEnter: !1,
                stopOnFocusIn: !1,
                stopOnInteraction: !1,
            };
            n.push(EmblaCarouselAutoScroll(t));
        }
        if (
            (e._autoheight && n.push(EmblaCarouselAutoHeight()),
            e._fade && n.push(EmblaCarouselFade()),
            this.classList.contains("product-gallery-slider") && this.classList.add("initialized"),
            (this.slider = EmblaCarousel(this.viewport, e, n)),
            e._autoscroll)
        ) {
            const t = this.slider.plugins()?.autoScroll;
            if (t) {
                const e = () => t.stop(),
                    n = () => t.play();
                this.viewport.addEventListener("mouseenter", e), this.viewport.addEventListener("mouseleave", n);
            }
        }
        const a = this;
        this.slider.on("init", () => a.classList.add("initialized"));
        if (!this.classList.contains("product-gallery-slider")) {
            const c = this.setupTweenScale(this.slider);
            this.slider.on("destroy", c);
            const l = this.setupStack(this.slider);
            this.slider.on("destroy", l);
        }
        const u = s && this.addPagination(this.slider, s);
        this.slider.on("destroy", u);
        this.addLazyLoad(this.slider);
        if (this.thumbOptions && this.thumbsViewport) {
            (this.thumbSlider = EmblaCarousel(this.thumbsViewport, JSON.parse(this.thumbOptions.content.textContent))),
                this.thumbSlider.on("init", () => this.addLazyLoadForThumbnails(this.thumbSlider));
            const t = this.addThumbBtnsClickHandlers(this.slider, this.thumbSlider),
                e = this.addToggleThumbBtnsActive(this.slider, this.thumbSlider);
            this.slider.on("destroy", t).on("destroy", e),
                this.thumbSlider.on("destroy", t).on("destroy", e),
                this.thumbOptions.remove();
        } else {
            r && this.addDots(this.slider, r);
        }
        o && i && this.addArrows(this.slider, o, i);
        this.options.remove();
    }
}
customElements.define("mivo-slider", MivoSlider);
